import {FooterTabFragmentProps, FooterTabFragmentState} from "../../shared/FooterTabFragment";
import React, {ReactElement} from "react";
import {StyledContainer} from "../../shared/StyledComponents";
import {PD_LG} from "../../shared/dimens";
import {BaseAppTabFragment} from "../BaseAppTabFragment";
import {Grid} from "@mui/material";
import {AppletCard} from "./AppletCard";
import {PathComponent} from "../../shared";
import {Outlet} from "react-router-dom";
import {APPLETS} from "../Applets";

type HomeFragmentProps = FooterTabFragmentProps & {}

type HomeFragmentState = FooterTabFragmentState & {}

export class AppsFragment extends BaseAppTabFragment<HomeFragmentProps, HomeFragmentState> {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: ":appletId",
        render: pathProps => {
          const appletId = pathProps.params.appletId;
          if (appletId) {
            return APPLETS.find(applet => applet.id === appletId)?.render(pathProps);
          }
          return null;
        },
      },
    ];
  }

  renderTabContent(): ReactElement {
    const appletId = this.props.path.params.appletId;
    if (appletId) {
      return <Outlet/>;
    }
    return <StyledContainer size={"xlg"} style={{padding: PD_LG}}>
      <Grid container spacing={2}>
        {APPLETS.map(applet => <Grid item xs={6}>
            <AppletCard applet={applet} onClick={() => this.props.path.navigate(applet.id)}/>
          </Grid>
        )}
      </Grid>
    </StyledContainer>;
  }
}